import React from 'react';
import PropTypes from 'prop-types';
import { actionsMap } from '@constants/logs';
import CustomTooltip from '@shared/custom-tooltip';
import './icon.scss';

const Icon = ({ action, attrs, type }) => {
  const getActionTemplate = () => actionsMap[action];

  const getTooltip = () => {
    const template = getActionTemplate();
    const { tooltip } = template;
    if (typeof tooltip === 'string') {
      return tooltip;
    }
    return tooltip(type, attrs);
  };

  const getIcon = () => {
    const template = getActionTemplate();
    const { icon } = template;
    if (typeof icon === 'object') {
      return icon;
    }
    return icon(attrs);
  };

  return (
    <CustomTooltip title={getTooltip()} placement="bottom-start">
      <div role="presentation" styleName="activity-logs-icon">
        {getIcon()}
      </div>
    </CustomTooltip>
  );
};

Icon.propTypes = {
  action: PropTypes.string,
  attrs: PropTypes.object,
  type: PropTypes.string
};

export default Icon;
